import React from 'react';
import { withRouter } from 'react-router';
import './generalCSS.scss';

const FirstScreen = ({ onClick, history: { push } }) => (
    <>
        <br />
        <img src="./images/otherIcons/hilma.svg" id="hilma" alt="hilma" />
        <br /><br /><br />
        <img src="./images/otherIcons/corona-2.svg" alt="corona" />
        <br />
        <div id="first-main-text"> מאגר ארצי להתנדבות בשעת חירום </div>
        <div id="first-main-text">  זה הזמן להירתם לטובת הקהילה </div>
        <div id="register-text">הרשמה קצרה <br /> והצטרפת למעגל הנתינה</div>
       
        <button id="first-button" onClick={onClick}>אני רוצה להצטרף היום</button>
        <br />
        <div onClick={() => push("/welcome")} id="first-go-to-login">התחברות מנהל</div>
    </>
)

export default withRouter(FirstScreen);